'use client'
import { salesStaticService } from '@/root/shared-api'
import useSWR from 'swr/immutable'
import { BoraTheme } from '@/root/shared-types'
import { getStyledHTML } from '@/root/utils/getStyledHTML'
import { useCustomRouter } from '@/root/shared-hooks'

export function useGetPageContent(slug: string, theme: BoraTheme) {
  const { locale } = useCustomRouter()
  const {
    data: page,
    error,
    isLoading,
  } = useSWR([`/pages/${locale}`, slug], () => salesStaticService.getPages(locale, slug))

  const speciallyHandledSlugs = ['news', 'tariffs']

  if (!speciallyHandledSlugs.includes(slug) && page && 'body' in page) {
    page.body = getStyledHTML({ body: page.body || '', slug, theme }) || ''
  }

  return {
    pageContent: { slug, page },
    error,
    isLoading,
  }
}
